import { getAvailableSizes } from "./productUtils";

const keyOf = (item) => String(item?.sku ?? item?.id ?? "");

// Units on hand for one size, straight from the catalog.
export const getSizeStock = (product, size) => {
  const entry = (product?.sizes || []).find(
    (s) => String(s.size) === String(size)
  );
  return entry ? Number(entry.qty) || 0 : 0;
};

// Stock minus whatever this visitor already holds in their cart.
// NOTE: still advisory — the browser can't enforce it. Making stock
// authoritative needs a server-side decrement on order creation.
export const getAvailableInventory = (product, selectedSize, cart = []) => {
  if (product?.outOfStock) return 0;

  const stock = getSizeStock(product, selectedSize);
  const inCart = cart
    .filter(
      (item) =>
        keyOf(item) === keyOf(product) &&
        String(item.selectedSize) === String(selectedSize)
    )
    .reduce((sum, item) => sum + item.quantity, 0);

  return Math.max(0, stock - inCart);
};

export const isSizeInStock = (product, size, cart) =>
  getAvailableInventory(product, size, cart) > 0;

export const getOutOfStockSizes = (product, availableSizes, cart) =>
  (availableSizes || getAvailableSizes(product)).filter(
    (size) => !isSizeInStock(product, size, cart)
  );
